import { render, staticRenderFns } from "./DocumentsEdit.vue?vue&type=template&id=38e9538c"
import script from "./DocumentsEdit.vue?vue&type=script&lang=js"
export * from "./DocumentsEdit.vue?vue&type=script&lang=js"
import style0 from "./DocumentsEdit.vue?vue&type=style&index=0&id=38e9538c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports